import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { LoginPage } from './pages/LoginPage';
import { WelcomePage } from './pages/guest/WelcomePage';
import { ReportPage } from './pages/guest/ReportPage';
import { ConfirmationPage } from './pages/guest/ConfirmationPage';
import { FornitoreHomePage } from './pages/fornitore/HomePage';
import { BeforePhotosPage } from './pages/fornitore/BeforePhotosPage';
import { CleaningInProgressPage } from './pages/fornitore/CleaningInProgressPage';
import { AfterPhotosPage } from './pages/fornitore/AfterPhotosPage';
import { CompletionConfirmationPage } from './pages/fornitore/CompletionConfirmationPage';
import { SummaryPage } from './pages/fornitore/SummaryPage';
import { ManutenzioneHomePage } from './pages/manutenzione/HomePage';
import { ReportsDetailPage } from './pages/manutenzione/ReportsDetailPage';
import { ManutenzioneBeforePhotosPage } from './pages/manutenzione/BeforePhotosPage';
import { InterventionInProgressPage } from './pages/manutenzione/InterventionInProgressPage';
import { CompletionFormPage } from './pages/manutenzione/CompletionFormPage';
import { ManutenzioneCompletionConfirmationPage } from './pages/manutenzione/CompletionConfirmationPage';
import { HostHomePage } from './pages/host/HomePage';
import { AccessHistoryPage } from './pages/host/AccessHistoryPage';
import { InterventionsHistoryPage } from './pages/host/InterventionsHistoryPage';
import { InterventionDetailPage } from './pages/host/InterventionDetailPage';
import { ReferencePhotosPage } from './pages/host/ReferencePhotosPage';
import { ActiveReportDetailPage } from './pages/host/ActiveReportDetailPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function Layout() {
  return <div className="min-h-screen bg-gray-light font-inter pt-24" data-id="element-0">
      <Header data-id="element-1" />
      <main className="w-full" data-id="element-2">
        <Outlet data-id="element-3" />
      </main>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-4">
      <ScrollToTop data-id="element-5" />
      <AuthProvider data-id="element-6">
        <LanguageProvider data-id="element-7">
          <Routes data-id="element-8">
            <Route path="/" element={<LoginPage data-id="element-10" />} data-id="element-9" />

            {/* Protected Routes with Layout */}
            <Route element={<Layout data-id="element-12" />} data-id="element-11">
              {/* Guest Flow */}
              <Route path="/guest" element={<WelcomePage data-id="element-14" />} data-id="element-13" />
              <Route path="/guest/report" element={<ReportPage data-id="element-16" />} data-id="element-15" />
              <Route path="/guest/confirmation" element={<ConfirmationPage data-id="element-18" />} data-id="element-17" />

              {/* Fornitore Flow */}
              <Route path="/fornitore" element={<FornitoreHomePage data-id="element-20" />} data-id="element-19" />
              <Route path="/fornitore/before-photos" element={<BeforePhotosPage data-id="element-22" />} data-id="element-21" />
              <Route path="/fornitore/cleaning-in-progress" element={<CleaningInProgressPage data-id="element-24" />} data-id="element-23" />
              <Route path="/fornitore/after-photos" element={<AfterPhotosPage data-id="element-26" />} data-id="element-25" />
              <Route path="/fornitore/summary" element={<SummaryPage data-id="element-28" />} data-id="element-27" />

              {/* Manutenzione Flow */}
              <Route path="/manutenzione" element={<ManutenzioneHomePage data-id="element-30" />} data-id="element-29" />
              <Route path="/manutenzione/reports/:propertyId" element={<ReportsDetailPage data-id="element-32" />} data-id="element-31" />
              <Route path="/manutenzione/before-photos/:propertyId" element={<ManutenzioneBeforePhotosPage data-id="element-34" />} data-id="element-33" />
              <Route path="/manutenzione/intervention/:propertyId" element={<InterventionInProgressPage data-id="element-36" />} data-id="element-35" />
              <Route path="/manutenzione/complete/:propertyId" element={<CompletionFormPage data-id="element-38" />} data-id="element-37" />

              {/* Host Flow */}
              <Route path="/host" element={<HostHomePage data-id="element-40" />} data-id="element-39" />
              <Route path="/host/active-report" element={<ActiveReportDetailPage data-id="element-42" />} data-id="element-41" />
              <Route path="/host/access-history" element={<AccessHistoryPage data-id="element-44" />} data-id="element-43" />
              <Route path="/host/interventions" element={<InterventionsHistoryPage data-id="element-46" />} data-id="element-45" />
              <Route path="/host/intervention/:id" element={<InterventionDetailPage data-id="element-48" />} data-id="element-47" />
              <Route path="/host/reference-photos" element={<ReferencePhotosPage data-id="element-50" />} data-id="element-49" />
            </Route>

            {/* Completion Confirmations - No Header */}
            <Route path="/fornitore/completion-confirmation" element={<CompletionConfirmationPage data-id="element-52" />} data-id="element-51" />
            <Route path="/manutenzione/completion-confirmation" element={<ManutenzioneCompletionConfirmationPage data-id="element-54" />} data-id="element-53" />

            {/* Catch all redirect */}
            <Route path="*" element={<Navigate to="/" replace data-id="element-56" />} data-id="element-55" />
          </Routes>
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>;
}